import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Doklad = {
	name: NAME,
	apiProvider,
	router,
};
